import Modal from "@mui/material/Modal";
import { Grid, Button, Tabs, Tab } from "@mui/material";
import { IoClose } from "react-icons/io5";
import React, { useEffect, useState } from "react";
import "../../SelfServe/InfluencerStepper.css";

export default function NewBannerModal(props) {
  const colorURLs = [
    "https://fakeimg.pl/1200x400/ffbe0b/ffbe0b", // Soft Coral
    "https://fakeimg.pl/1200x400/fb5607/fb5607", // Warm Blush
    "https://fakeimg.pl/1200x400/ff006e/ff006e", // Golden Sand
    "https://fakeimg.pl/1200x400/8338ec/8338ec", // Sage Green
    "https://fakeimg.pl/1200x400/3a86ff/3a86ff", // Seafoam Green
    "https://fakeimg.pl/1200x400/06d6a0/06d6a0", // Seafoam Green
    "https://fakeimg.pl/1200x400/363B4D/363B4D", // Mint Cream
    "https://fakeimg.pl/1200x400/e6e6e9/e6e6e9", // Mint Cream
  ];

  const [presetSelected, setPresetSelected] = useState(null);
  const [selectedBanner, setSelectedBanner] = useState(null); // Local state for preview
  const [previewType, setPreviewType] = useState("desktop"); // 'mobile', 'desktop', 'widescreen'

  // Initialize selectedBanner with the current banner when the modal opens
  useEffect(() => {
    if (props.influencerBannerUpdated !== "") {
      setSelectedBanner(props.influencerBannerUpdated);
    } else {
      setSelectedBanner(props.influencerBanner || "");
    }
  }, [props.influencerBanner, props.influencerBannerUpdated, props.open]);

  const getPreviewStyle = () => {
    switch (previewType) {
      case "mobile":
        return {
          height: "100%",
          width: "100%",
          aspectRatio: "2.5/1",
          maxWidth: "400px",
          margin: "0px auto 20px auto",
        };
      case "desktop":
        return {
          height: "100%",
          width: "100%",
          aspectRatio: "4/1",
          maxWidth: "400px",
          margin: "0px auto 20px auto",
        };
      case "widescreen":
        return {
          height: "100%",
          width: "100%",
          aspectRatio: "6/1",
          maxWidth: "400px",
          margin: "0px auto 20px auto",
        };
      default:
        return {};
    }
  };

  // Handle file upload locally
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileUrl = URL.createObjectURL(file);
      setSelectedBanner(fileUrl);
      props.setState({ influencerBannerUpdatedFile: file }); // Keep file for upload later
    }
  };

  // Handle preset selection locally
  const handlePresetSelection = (colorURL, index) => {
    setPresetSelected(index);
    setSelectedBanner(colorURL);
    fetch(colorURL)
      .then(response => response.blob())
      .then(blob => {
        const file = new File([blob], "banner.png", { type: blob.type });
        props.setState({ influencerBannerUpdatedFile: file }); // Keep file for upload later
      })
      .catch(error => console.error('Error creating file from URL:', error));
  };

  // Confirm and propagate changes
  const handleConfirm = () => {
    props.setState({
      isBannerModalOpen: false,
      bannerChangesMade: true,
      influencerBannerUpdated: selectedBanner, // Only set here
    });
  };

  // Reset selection locally
  const handleRemoveImage = () => {
    setSelectedBanner("");
    setPresetSelected(null);
    props.setState({ influencerBannerUpdatedFile: "" });
  };

  return (
    <Modal
      open={props.open}
      onClose={() => {
        props.setState({ isBannerModalOpen: false });
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      disableAutoFocus={true}
      sx={{
        display: "flex",
        overflow: "auto",
        height: "auto",
        outline: "none",
        border: "none",
        backgroundColor: "rgba(0,0,0,0.2)",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          overflow: "auto",
          outline: "none",
          border: "none",
          display: "flex",
        }}
      >
        <Grid
          container
          justifyContent="center"
          sx={{
            paddingTop: "20px",
            paddingBottom: "20px",
            width: "100%",
            borderRadius: "5px",
            margin: "auto",
            maxWidth: "650px",
            outline: "none",
          }}
        >
          <Grid
            style={{
              zIndex: "100",
              justifyContent: "flex-end",
              alignItems: "center",
              padding: props.windowWidth < 400 ? "20px" : "30px 30px",
              boxSizing: "border-box",
              width: "100%",
              outline: "0px",
              borderRadius: "5px",
              maxWidth: "500px",
              minWidth: props.windowWidth < 600 ? "100%" : "500px",
              position: "relative",
              backgroundColor: "#fff",
              borderRadius: "10px",
              height: "auto",
              margin: "auto",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                "&:hover": { cursor: "pointer" },
              }}
            >
              <a
                onClick={() => {
                  props.setState({
                    isBannerModalOpen: false,
                  });
                }}
              >
                <IoClose className={"modal-close-icon"} />
              </a>
            </div>
            <Grid
              container
              sx={{
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                zIndex: "1000",
              }}
            >
              <div style={{ width: "100%", display: "block", margin: "0px 0px" }}>
                <h3
                  style={{
                    color: "var(--light-theme-text-color)",
                    fontSize: "20px",
                    fontFamily: "var(--main-font-family)",
                    fontWeight: "600",
                    textAlign: "center",
                  }}
                >
                  Update Banner Image
                </h3>
                <div style={{ display: "flex", width: "100%" }}>
                  <p
                    style={{
                      textAlign: "center",
                      margin: "auto auto 15px auto",
                      color: "#6E89AF",
                      fontWeight: "600",
                    }}
                  >
                    {selectedBanner === ""
                      ? "Select a new background image"
                      : "Preview your background"}
                  </p>
                </div>

                <div style={{ maxWidth: "400px", margin: "auto" }}>
                  {selectedBanner !== "" && (
                    <Tabs
                      value={previewType}
                      onChange={(e, newValue) => setPreviewType(newValue)}
                      sx={{
                        "& .MuiTabs-flexContainer": {
                          justifyContent: "space-between",
                          margin: "auto",
                          color: "#000",
                        },
                        "& .MuiTab-root": {
                          flex: 1,
                          textTransform: "none",
                          color: "#000",
                          maxWidth: "130px",
                          borderRadius: "8px",
                          transition: "background-color 0.3s",
                          border: "1.5px solid #D3DCE7",
                        },
                        "& .Mui-selected": {
                          border: "1.5px solid #000",
                          color: "#000",
                        },
                      }}
                      TabIndicatorProps={{ style: { display: "none" } }}
                    >
                      <Tab
                        value="mobile"
                        label={<span style={{ color: "#000" }}>Mobile</span>}
                      />
                      <Tab
                        value="desktop"
                        label={<span style={{ color: "#000" }}>Desktop</span>}
                      />
                      <Tab
                        value="widescreen"
                        label={
                          <span style={{ color: "#000" }}>
                            {props.windowWidth < 600 ? "Wide" : "Wide Desktop"}
                          </span>
                        }
                      />
                    </Tabs>
                  )}
                </div>

                {selectedBanner !== "" ? (
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      position: "relative",
                      maxWidth: "400px",
                      margin: "0px auto",
                      minHeight: "200px",
                    }}
                  >
                    <div
                      style={{
                        height: "100%",
                        width: "100%",
                        zIndex: "9999",
                        backgroundColor: "pink",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: "0",
                          bottom: "0",
                          left: "0",
                          right: "0",
                          width: "max-content",
                          height: "50px",
                          margin: "auto",
                          display: "flex",
                        }}
                      >
                        <div
                          style={{
                            justifyContent: "center",
                            textAlign: "center",
                            width: "100%",
                            margin: "auto",
                            color: "#fff",
                            backgroundColor: "rgb(0,0,0,0.3)",
                            padding: "5px 10px",
                            borderRadius: "100px",
                            fontSize: "12px",
                          }}
                        >
                          {previewType === "mobile"
                            ? "350px x 150px"
                            : previewType === "desktop"
                            ? "1200px x 300px"
                            : "1800px x 300px"}
                        </div>
                      </div>
                    </div>
                    <Button
                      fullWidth
                      variant="contained"
                      sx={{
                        position: "absolute",
                        right: "-10px",
                        top:
                          props.windowWidth < 400
                            ? previewType === "mobile"
                              ? "calc(10px + 1vh)"
                              : previewType === "desktop"
                              ? "calc(40px + 1vh)"
                              : "calc(55px + 1vh)"
                            : previewType === "mobile"
                            ? "10px"
                            : previewType === "desktop"
                            ? "40px"
                            : "55px",
                        textTransform: "none",
                        width: "30px",
                        borderRadius: "600px",
                        boxShadow: "none",
                        fontWeight: "600",
                        margin: "auto",
                        maxWidth: "30px",
                        color: "#000",
                        minWidth: "30px",
                        backgroundColor: "white",
                        height: "30px",
                        padding: "0px",
                        border: "1.5px solid #D3DCE7",
                        ":hover": {
                          color: "#222",
                          backgroundColor: "white",
                          border: "1.5px solid #D3DCE7",
                          boxShadow: "none",
                        },
                      }}
                      className="image_update_button"
                      type="submit"
                      value="submit"
                      onClick={handleRemoveImage}
                    >
                      <IoClose style={{ fontSize: "16px" }} />
                    </Button>
                    <img
                      src={selectedBanner}
                      style={{
                        ...getPreviewStyle(),
                        border: "2px solid #D3DCE7",
                        objectFit: "cover",
                        borderRadius: "8px",
                        margin: "auto",
                      }}
                    />
                  </div>
                ) : (
                  <div
                    className="video-upload"
                    onClick={() => {
                      const input = document.getElementById("banner_image_upload_desktop");
                      input.click();
                    }}
                    style={{
                      height: "100%",
                      width: "100%",
                      aspectRatio: "16/6",
                      maxWidth: "400px",
                      margin: "0px auto 20px auto",
                    }}
                  >
                    <div style={{ margin: "auto" }}>
                      <p
                        style={{
                          color: "#6E89AF",
                          fontWeight: "600",
                          fontSize: "12px",
                        }}
                      >
                        Click to browse images
                      </p>
                    </div>
                    <input
                      type="file"
                      id="banner_image_upload_desktop"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={handleFileUpload}
                    />
                  </div>
                )}

                <div
                  style={{
                    maxWidth: "400px",
                    margin: "20px auto 0px auto",
                    padding: "20px",
                  }}
                >
                  <div style={{ display: "flex", width: "100%" }}>
                    <p
                      style={{
                        textAlign: "center",
                        margin: "auto auto 15px auto",
                        color: "#6E89AF",
                        fontWeight: "600",
                      }}
                    >
                      Or select a color preset
                    </p>
                  </div>
                  <Grid
                    container
                    spacing={2}
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "space-around",
                      fontFamily: "roboto",
                    }}
                  >
                    {colorURLs.map((colorURL, index) => (
                      <Grid
                        item
                        xs={2.5}
                        sm={1.5}
                        lg={1.5}
                        sx={{ display: "flex", justifyContent: "center" }}
                        key={index}
                      >
                        <div
                          onClick={() => handlePresetSelection(colorURL, index)}
                          style={{
                            width: "100%",
                            paddingTop: "100%",
                            position: "relative",
                            cursor: "pointer",
                            borderRadius: "5px",
                            overflow: "hidden",
                            outline:
                              presetSelected === index
                                ? "2px solid var(--brand-color)"
                                : "2px solid #F5F9FF",
                          }}
                        >
                          <img
                            src={colorURL}
                            alt="Preset"
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                      </Grid>
                    ))}
                  </Grid>
                </div>
              </div>
              <Button
                fullWidth
                variant="contained"
                sx={{
                  backgroundColor: "var(--brand-color)",
                  fontSize: "14px",
                  textTransform: "none",
                  width: "100%",
                  borderRadius: "6px",
                  boxShadow: "none",
                  marginBottom: "20px",
                  fontWeight: "600",
                  maxWidth: "400px",
                  marginTop: "30px",
                  ":hover": {
                    bgcolor: "var(--brand-color-hover)",
                    color: "white",
                    boxShadow: "none",
                  },
                }}
                className="image_update_button"
                type="submit"
                value="submit"
                // onClick={handleConfirm}
                onClick={() => {
                  
                  props.setState({
                    isBannerModalOpen: false,
                    bannerChangesMade: true,
                    influencerBannerUpdated: selectedBanner, // Only set here
                  });
                }}
              >
                Finished Updating Image
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </Modal>
  );
}